import React, { useCallback } from 'react';
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons/faExternalLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text } from 'ui-components/components/text';
import { TextType } from 'ui-components/components/text/text-type';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import EmptyBoxIcon from './inventorysetup.svg';
import { messages } from './messages';
import styles from './styles.module.less';
import HelpArticleLink from '../../../../../../components/help-article-link';
import { linkIDs } from '../../../../../../services/link-service/links';
/**
 * Empty state component shown when no external inventory sources are configured
 * Displays informational content and action buttons to setup inventory sources
 * @returns {JSX.Element} The external inventory empty state component
 */
export const ExternalInventoryEmptyState = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const handleSetupSourcesClick = useCallback(() => {
    navigate('/settings/inventorysync');
  }, [navigate]);

  return (
    <FlexColumn className={styles['empty-state-container']}>
      {EmptyBoxIcon ? (
        <img alt={intl.formatMessage(messages.emptyStateHeader)} className={styles['empty-state-icon']} src={EmptyBoxIcon} />
      ) : null}

      <div className={styles['empty-state-content']}>
        <Text className={styles['empty-state-header']} textType={TextType.H3} value={messages.emptyStateHeader} />
        <Text className={styles['empty-state-description']} textType={TextType.Paragraph} value={messages.emptyStateDescription} />
      </div>

      <FlexRow className={styles['actions-row']}>
        <Button onClick={handleSetupSourcesClick} theme={THEME_CONSTANTS.primary}>
          <Text textType={TextType.Paragraph} value={messages.setupSourcesButton} />
        </Button>
        <FlexRow className={styles['learn-more-link-container']}>
          <HelpArticleLink articleId={linkIDs.InventorySync} className={styles['learn-more-link']}>
            <Text textType={TextType.Paragraph} value={messages.learnMoreButton} />
          </HelpArticleLink>
          <FontAwesomeIcon className={styles['external-link-icon']} icon={faExternalLink} />
        </FlexRow>
      </FlexRow>
    </FlexColumn>
  );
};
